import { useTranslation } from 'react-i18next'

export interface NavigationItem {
    key: string
    path: string
    label: string
    isResume?: boolean
}

export function useNavigationConfig() {
    const { t } = useTranslation()

    const navigationItems: NavigationItem[] = [
        { key: 'dashboard', path: '/dashboard', label: t('navigation:dashboard') },
        { key: 'resume', path: '', label: t('navigation:resume'), isResume: true },
    ]

    const authItems: NavigationItem[] = [
        { key: 'login', path: '/login', label: t('navigation:login') },
        { key: 'register', path: '/register', label: t('navigation:register') },
    ]

    return { navigationItems, authItems }
}
